import React from 'react';

import FinalFeature from '@features/final';

function ExternalElearningFinalPage() {
  return <FinalFeature />;
}

export default ExternalElearningFinalPage;
